import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionAccionistasEditarComponent {
  clienteId
  contactoId
  onClose
  error = null
  catalogos = {}
  procesando = false

  constructor ($state, ClienteInformacionContacto) {
    this.ClienteInformacionContacto = ClienteInformacionContacto
    this.$state = $state
  }

  $onInit () {
    this.promise = this.ClienteInformacionContacto.get(this.clienteId, this.contactoId)
      .then(({data}) => (this.data = data, console.info('informacion', this.data)))
  }

  actualizar () {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    this.ClienteInformacionContacto.put(this.clienteId, this.contactoId, this.data)
      .then(() => (this.cerrar()))
      .catch(({data}) => (this.error = data))
      .finally(() => (this.procesando = false))
  }

  cerrar () {
    this.$state.go('cliente.informacion.contactos')
  }

  actualizarNotificaciones () {
    if (!this.data.correo) this.data.notificaciones.correo = false
  }
}

module.component('clienteInformacionContactosEditar', {
  controller: ClienteInformacionAccionistasEditarComponent,
  template,
  bindings: {
    clienteId: '<',
    contactoId: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/contacto/editar/component.js